class DermaIdModalDialog extends ModalDialog {
  constructor() {
    super();
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector('.template-popup');
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    if (popup) popup.loadContent();
    const contentEl = this.querySelector('[role="dialog"]');
    const focusEl =  this.querySelector('input[type="text"]') || contentEl;
    trapFocus(this, focusEl);
    window.pauseAllMedia();

    if (focusEl.tagName === 'INPUT') {
      focusEl.addEventListener('focusout', () => {
        contentEl.focus();
      });
    }
    
    // Prevent background scroll
    document.body.style.overflow = 'hidden';
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    document.body.dispatchEvent(new CustomEvent('modalClosed'));
    this.removeAttribute('open');
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();

    // Restore background scroll
    document.body.style.overflow = '';
  }
}
customElements.define('derma-id-modal-dialog', DermaIdModalDialog);
